<template>
  <div class="evaluate-feedback-wrapper" v-if="show">
    <div class="evaluate-feedback">
      {{ labels.rateFeedback }}
      <div v-if="loading" class="evaluate-feedback-loading">
        <loading />
      </div>
      <div v-else>
        <span
          id="very-unhappy"
          class="emoji"
          @click="emitRateMessage({ rating: 'very-unhappy' })"
        >
          😠
        </span>
        <b-tooltip target="very-unhappy">
          <div class="tooltip-info">
            {{ labels.rating.veryUnhappy }}
          </div>
        </b-tooltip>
        <span
          id="unhappy"
          class="emoji"
          @click="emitRateMessage({ rating: 'unhappy' })"
        >
          🙁
        </span>
        <b-tooltip target="unhappy">
          <div class="tooltip-info">
            {{ labels.rating.unhappy }}
          </div>
        </b-tooltip>
        <span
          id="no-comments"
          class="emoji"
          @click="emitRateMessage({ rating: 'no-comments' })"
        >
          😐
        </span>
        <b-tooltip target="no-comments">
          <div class="tooltip-info">
            {{ labels.rating.noComments }}
          </div>
        </b-tooltip>
        <span
          id="good"
          class="emoji"
          @click="emitRateMessage({ rating: 'good' })"
        >
          😃
        </span>
        <b-tooltip target="good">
          <div class="tooltip-info">
            {{ labels.rating.good }}
          </div>
        </b-tooltip>
        <span
          id="love-it"
          class="emoji"
          @click="emitRateMessage({ rating: 'love-it' })"
        >
          😍
        </span>
        <b-tooltip target="love-it">
          <div class="tooltip-info">
            {{ labels.rating.loveIt }}
          </div>
        </b-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Loading from '@/components/Shared/Loading.vue'

const props = {
  show: {
    default: false,
    required: false,
    type: Boolean,
  },
}

export default {
  components: {
    Loading,
  },
  data() {
    return {
      loading: false,
    }
  },
  props,
  computed: {
    ...mapGetters({
      resources: 'resources',
    }),
    labels: function() {
      return this.resources.page.home.feedbacks.tickets
    },
  },
  methods: {
    emitRateMessage({ rating }) {
      this.loading = true
      this.$emit('rateMessage', { rating })
    },
  },
}
</script>

<style lang="scss">
@import '~@/styles/custom/colors';
.evaluate-feedback-wrapper {
  text-align: center;

  .evaluate-feedback {
    display: inline-block;
    background-color: map-get($theme-colors, 'gray08');
    border-radius: 40px;
    width: 300px;
    height: 90px;
    padding: 10px;
    font-size: 10pt;
    margin-top: 30px;
    margin-bottom: 20px;

    .evaluate-feedback-loading {
      height: 40px;
      .lds-ellipsis {
        div {
          top: 15px !important;
        }
      }
    }

    div {
      padding-top: 5px;

      .emoji {
        font-size: 18pt;
        margin: 10px;
        cursor: pointer;
        display: inline-block;
      }

      .emoji:hover {
        margin: -2px 5px -2px 5px;
        font-size: 26pt;
      }
    }
  }
}
</style>
